export default "__VITE_ASSET__42215636__"